@if (workflowConfig.workflow === Workflow.SimpleDocx) {
  <app-awesomedoc-workflow-config
    [parent]="this"
    (delete)="delete()"
    (copyDirectLink)="copyDirectLink()"
    (discardLocalChanges)="discardLocalChanges($event)"
    (updateDocumentForDestinationType)="updateDocumentForDestinationType($event, outputFileTypeSectionFormGroup, destinationsForOutputFileType)"
    (onDocxFileNameChange)="onDocxFileNameChange($event)"
    (saveWorkflowConfig)="saveWorkflowConfig()"
  ></app-awesomedoc-workflow-config>
}

@if (workflowConfig.workflow === Workflow.DocumentMerge) {
  <app-docmerge-workflow-config
    [parent]="this"
    [allowedSectionTypes]="allowedSectionTypes"
    (delete)="delete()"
    (copyDirectLink)="copyDirectLink()"
    (discardLocalChanges)="discardLocalChanges($event)"
    (updateDocumentForDestinationType)="updateDocumentForDestinationType($event, outputFileTypeSectionFormGroup, destinationsForOutputFileType)"
    (onDocxFileNameChange)="onDocxFileNameChange($event)"
    (saveWorkflowConfig)="saveWorkflowConfig()"
  ></app-docmerge-workflow-config>
}
